@import (reference) '../../../../../../constants/spacing.module.less';

.details-grid {
  flex-wrap: wrap;
}

.details-column {
  flex: 1;
  min-width: 200px;
  margin-bottom: @space-16;
  margin-right: @space-32;

  &:last-child {
    margin-right: 0;
  }
}

.full-width-column {
  flex: 1 1 100%;
  margin-bottom: @space-16;
}

.header {
  padding: @space-8 @space-0;
  border-bottom: none;
}

.header-content {
  min-height: 30px;
}

.expandable-header-container {
  padding: @space-8 @space-0;
}

.expandable-content-container {
  padding: 0 0 @space-16;
}

.shipping-details-wrapper {
  margin: @space-0 @space-16;
  border-color: var(--grey-300);
}

.date-picker {
  display: flex;
  height: 32px;
  width: 100%;
  background-color: var(--white);

  input {
    height: 32px;
    border: 1px solid var(--grey-500);
    border-right: none;
  }

  button {
    height: 32px;
    border: 1px solid var(--grey-500);
    display: flex;
  }
}

.notes-input-wrapper {
  flex: 1;
  min-height: 68px;
}
